import { Fragment, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Menu, message, Modal, Spin, Tag } from "antd";
import { UIPageListing } from "../../components";
import QueueAnim from "rc-queue-anim";
import Filters from "./filters";
import { teamsService } from "../../redux/services";
import ModalForm from "./form";
import moment from "moment";

import { generalActions } from "./../../redux/actions";

const config = {
	title            : "Fluxos de Aprovação",
	permissionPrefix : "roles",
	list             : "teams",
	searchPlaceholder: "Buscar por nome",
	orders           : [
		{
			label  : "Mais recentes",
			field  : "id",
			sort   : "desc",
			default: true,
		},
		{
			label: "Mais antigos",
			field: "id",
			sort : "asc",
		},
		{
			label: "Nome A|Z",
			field: "nome",
			sort : "asc",
		},
		{
			label: "Nome Z|A",
			field: "nome",
			sort : "desc",
		},
	],
};


const Teams = ({ permissions, onChangeListType, listType }) => {
    const filtersRef = useRef();
    const formRef = useRef();
    
    const defaultOrder = config.orders.find(o => o.default);
    
    const [isLoading, setIsLoading] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        current : 1,
        pageSize: 20,
        total   : 0,
    });
    const [orderByLabel, setOrderByLabel] = useState(defaultOrder.label);
    const [orderByField, setOrderByField] = useState(defaultOrder.field);
    const [orderBySort, setOrderBySort] = useState(defaultOrder.sort);
    const [search, setSearch] = useState("");
    
    // Actions
    const [formModalVisible, setFormModalVisible] = useState(false);
    const [formModalType, setFormModalType] = useState('create');
    const [filtersModalVisible, setFiltersModalVisible] = useState(false);
    const [activeLoadings, setActiveLoadings] = useState([]);

    // Filters
    const [filters, setFilters] = useState({
        ativo     : 1,
        created_at: null,
    });

    const editOpen = ({uuid}) => {
        setFormModalType('edit');
        formRef.current.onOpen('edit', uuid)
        setFormModalVisible(true);
    }

    const showOpen = ({uuid}) => {
        setFormModalType('show');
        formRef.current.onOpen('show', uuid)
        setFormModalVisible(true);
    }

    const createOpen = () => {
        setFormModalType('create');
        setFormModalVisible(true);
        formRef.current.onOpen('create')
    }

    const deleteConfirmed = (uuid) => {
        teamsService.destroy({ uuid })
            .then(() => {
                fetchGetAll();
            })
            .catch((data) => {
                Modal.error({
                    title: "Ocorreu um erro!",
                    content: String(data),
                });
            });
    }

    const deleteConfirm = ({uuid}) => {
        Modal.confirm({
            title          : "Confirmar exclusão!",
            content        : "Tem certeza de que deseja excluir este registro?",
            okText         : "Excluir",
            autoFocusButton: null,
            onOk           : () => {
                return deleteConfirmed(uuid);
            }
        });
    };

    const menuItem = (item) => (
		<Menu className="actions-dropdown-menu">
			{permissions.includes(config.permissionPrefix + ".show") && <Menu.Item key="show">
				<a onClick={() => showOpen(item)}>
					<i className="fal fa-file" />Visualizar
				</a>
			</Menu.Item>}
			{permissions.includes(config.permissionPrefix + ".edit") && <Menu.Item key="edit">
				<a onClick={() => editOpen(item)}>
					<i className="fal fa-pen" />Editar
				</a>
			</Menu.Item>}
			{permissions.includes(config.permissionPrefix + ".delete") && <Menu.Item key="delete" className="divider btn-delete">
				<a onClick={() => deleteConfirm(item)}>
					<i className="fal fa-trash" />Excluir
				</a>
			</Menu.Item>}
		</Menu>
	);

	const columns = () => {
		const listTypeCard = listType === "card";
		return [
			{
				title : "Nome",
				// width: 150,
				render: (item) => listTypeCard ? <h3>{item.nome}</h3> : item.nome,
			},
			{
				title : "Descrição",
				// width: 150,
				render: (item) => listTypeCard ? <h3>{item.descricao}</h3> : item.descricao,
			},
			{
				title: "Data do Cadastro",
				className: "datetime card-block-width-2",
				render: (item) => {
					if (listTypeCard) {
						return (
							<Fragment>
								<i className="fal fa-plus-circle" style={{ marginRight: 5 }} />{moment(item.created_at).format("DD/MM/YYYY")}
							</Fragment>
						);
					}

					return moment(item.created_at).format("DD/MM/YYYY");
				}
			},
			{
				title    : "Status",
				className: "active no-ellipsis",
				width: 90,
				render   : (item) => activeLoadings.indexOf(item.uuid) !== -1 ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : <Tag color={item.ativo ? "#0acf97" :  "#fa5c7c"}>{item.ativo ? "Ativo" : "Inativo"}</Tag>
			},
			{
				title    : "Ações",
				className: "actions no-ellipsis",
				visible  : permissions.includes(config.permissionPrefix + ".show") || permissions.includes(config.permissionPrefix + ".edit") || permissions.includes(config.permissionPrefix + ".delete"),
				render   : (item) => (
					<Dropdown overlay={menuItem(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
						<Button icon={<i className="fal fa-ellipsis-v" />} />
					</Dropdown>
				),
			},
		];
	};

	const fetchGetAll = (init = false, exportItems = false) => {
        setIsLoading(true);		

		const data = {
			orderBy: `${orderByField}:${orderBySort}`,
			search : search,
		};

		if( exportItems )
		{
			data.exportItems = true;
		}
		else
		{
			data.page  = init ? 1 : pagination.current;
			data.limit = pagination.pageSize;
		}

		if( filters.recorrente !== null ) {
			data.recorrente = filters.recorrente;
		}

		if( filters.ativo !== null )
		{
			data.ativo = filters.ativo;
		}

		if( filters.created_at )
		{
			data.created_at = [
				filters.created_at[0].clone().startOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
				filters.created_at[1].clone().endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
			];
		}

		teamsService.getAll(data)
		.then((response) => {
            setData(response.data.data);
            setPagination({
                    ...pagination,
                    current: response.data.meta.current_page,
                    total  : response.data.meta.total,
                });
            setIsLoading(false);
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	const onListTypeChange = (type) => {
		onChangeListType(type);
	};

	const onPaginationChange = (page, pageSize) => {
        setPagination(prev => ({
            ...prev,
            current: page,
            pageSize,
        }));
	};

    useEffect(() => {
        fetchGetAll();
    }, [pagination.current, pagination.pageSize]);

    const onOrderChange = (value) => {
        const defaultOrder = config.orders.find(o => `${o.field}:${o.sort}` === value);

        if( !defaultOrder ) return null;

        setOrderByLabel(defaultOrder.label);
        setOrderByField(defaultOrder.field);
        setOrderBySort(defaultOrder.sort);
    };

    const onSearch = (value) => {
        setSearch(value);
    };

    const onSearchChange = (e) => {
        if( !e.hasOwnProperty("type") )
        {
            setSearch(e.target.value);
        }
    };

    /**
	 * Filter
	 */
	const filtersOpen = () => {
		setFiltersModalVisible(true);
        filtersRef.current.onOpen(filters);
	};

	const filtersOnClose = () => {
		setFiltersModalVisible(false);
	};

	const filtersOnComplete = (filters) => {
		setFiltersModalVisible(true);
		setFilters(filters);
	};

    useEffect(() => {
        fetchGetAll(true);
    }, [orderByLabel, orderByField, orderBySort, filters]);

    useEffect(() => {
        fetchGetAll(true);
    }, [search]);

    const formOnClose = () => {
        setFormModalVisible(false);
        fetchGetAll();
    }

    return (
        <QueueAnim className="site-content-inner">
            <div className="page-content fixed-header" key="1">
                <h1 className="page-title">{config.title}</h1>
                <UIPageListing
                    onSearch={onSearch}
                    onSearchChange={onSearchChange}
                    onPaginationChange={onPaginationChange}
                    onOrderChange={onOrderChange}
                    onListTypeChange={onListTypeChange}
                    onFiltersClick={filtersOpen}
                    isLoading={isLoading}
                    listType={listType}
                    orderByField={orderByField}
                    orderBySort={orderBySort}
                    orders={config.orders}
                    search={search}
                    searchPlaceholder={config.searchPlaceholder}
                    data={data}
                    pagination={pagination}
                    columns={columns()}
                    showFilters={true}
                    buttons={[
                        {
                            visible: permissions.includes(config.permissionPrefix + ".create"),
                            onClick: createOpen,
                            title  : "Incluir",
                            icon   : <i className="far fa-plus" />,
                        },
                    ]}
                />
            </div>

            <Filters 
                ref={filtersRef}
                visible={filtersModalVisible}
                onComplete={filtersOnComplete}
                onClose={filtersOnClose}
            />

            <ModalForm
                ref={formRef}
                visible={formModalVisible}
                formType={formModalType}
                onClose={formOnClose}
                onComplete={formOnClose}
            />
        </QueueAnim>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        permissions: state.auth.userData.permissions,
        listType   : state.general.listType[config.list],
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChangeListType: (type) => {
            dispatch(generalActions.changeListType(config.list, type));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Teams);